module.exports = __webpack_public_path__ + "images/97629d27d34def912d810474d8526124-HOLBOX-WHITE.png";